import React, { FC } from "react";
import { Form, Button } from "react-bootstrap";

import AuthLogo from "./components/AuthLogo";
import { RefreshIcon } from "./components/Icons";
import { UseTranslate } from "../hooks/Translate";

const EmailVerificationPage: FC = () => {
  const [translate] = UseTranslate();
  return (
    <div className="auth-wrapper">
      <div className="text-center">
        <AuthLogo />
      </div>

      <div className="mb-4">
        <h6>{translate('cas.registration.verificationOnEmail')}</h6>
        <div className="small">
          <span className="text-muted">
            {translate('cas.registration.verificationOnEmailAddress')}
          </span>
          <strong className="mx-2">mail@mail.ge</strong>
          <button className="link-button">{translate('cas.registration.change')}</button>
        </div>
      </div>

      <Form>
        <Form.Group className='mb-3' controlId="token">
          <Form.Label className="small key-icon">
            {translate('cas.registration.inputOneTimeCode')}
          </Form.Label>
          <Form.Control type="text" placeholder={translate('cas.registration.inputCode')} />
        </Form.Group>

        <div className="small my-4 d-flex justify-content-center">
          <div className="text-muted">
            <RefreshIcon />
            <span className="mx-1">{translate('cas.registration.codeResend')}</span>
          </div>
          <span className="resend-timer">(23)</span>
        </div>

        <Button variant="primary" type="submit" className="w-100">
          {translate('cas.registration.createAccount ')}
        </Button>
      </Form>
    </div>
  );
};

export default EmailVerificationPage;
